export const getAddressStreetEstateNo = (street?: string, estateNo?: string): string => {
  return `${street || ""} ${estateNo || ""}`.trim();
};
